import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitokolhapurcab() {



  const cardData = {
    keyword: " Mumbai to Kolhapur Cab",

"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Kolhapur cab services, ensuring a safe, smooth, and convenient long-distance journey for families, devotees, business travelers, and group tours. Whether you are planning a pilgrimage to Mahalaxmi Temple, a cultural trip, or a weekend getaway, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Kolhapur route covers approximately 370 to 400 km and takes around 7 to 8 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Kolhapur travel.",

"topPlaces": [
  {
    "title": "Mahalaxmi Temple Kolhapur",
    "description": "Mahalaxmi Temple is one of the most sacred Shakti Peethas in India, dedicated to Goddess Mahalaxmi. Devotees from all over the country visit this temple for blessings, spiritual peace, and divine experience. The temple is known for its beautiful architecture and powerful religious significance."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake is a scenic and peaceful attraction in Kolhapur, perfect for evening walks, boating, and relaxing with family. Surrounded by gardens and food stalls, it offers a calm escape from the city rush."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort is a historic hill fort located near Kolhapur, known for its connection with Chhatrapati Shivaji Maharaj. It offers panoramic views, historical architecture, and cool hill station weather."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Jyotiba Temple is a famous hilltop temple dedicated to Lord Jyotiba, located near Kolhapur. It is known for its spiritual importance, vibrant festivals, and stunning hill views."
  },
  {
    "title": "New Palace Museum",
    "description": "New Palace Museum is a royal palace showcasing artifacts, weapons, costumes, and memorabilia of the Kolhapur royal family. It is a great place to explore history and architecture."
  },
  {
    "title": "Shahu Maharaj Samadhi",
    "description": "Shahu Maharaj Samadhi is a respected memorial dedicated to Chhatrapati Shahu Maharaj, a great ruler known for social reforms and development in Kolhapur."
  },
  {
    "title": "Gaganbawda Hill Station",
    "description": "Gaganbawda is a beautiful hill station near Kolhapur offering lush greenery, misty mountains, waterfalls, and a peaceful environment ideal for nature lovers and monsoon trips."
  },
  {
    "title": "Radhanagari Wildlife Sanctuary",
    "description": "Radhanagari Wildlife Sanctuary is home to rich biodiversity including deer, bison, and birds. It is a perfect destination for wildlife enthusiasts and nature explorers."
  },
  {
    "title": "Kopeshwar Temple Khidrapur",
    "description": "Kopeshwar Temple is an ancient Hindu temple known for its unique architecture and intricate carvings. It is a hidden gem near Kolhapur for history and heritage lovers."
  },
  {
    "title": "Chandrakant Mandare Art Gallery",
    "description": "This art gallery showcases the works of famous Marathi artist Chandrakant Mandare, highlighting local culture, paintings, and heritage art of Maharashtra."
  }
],







services: [
  {
    name: "Mumbai to Kolhapur Cab",
    description: "Mumbai to Kolhapur cab service offers a comfortable and reliable long-distance journey to one of Maharashtra’s cultural and religious hubs. The route is known for smooth highways and scenic views, making the road trip enjoyable. Ideal for families, pilgrims, and business travelers, this service ensures safe and timely travel. Professional drivers and well-maintained vehicles enhance comfort. Customers can choose from sedan, SUV, and luxury cars. It guarantees a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Kolhapur Taxi",
    description: "Mumbai to Kolhapur taxi provides convenient and private travel with door-to-door pickup and drop facilities. This service is perfect for travelers seeking a hassle-free journey. Vehicles are clean and driven by experienced chauffeurs. Flexible travel timings add convenience. Suitable for family trips and corporate travel. It ensures a safe and comfortable ride."
  },
  {
    name: "Mumbai to Kolhapur Cab Service",
    description: "Mumbai to Kolhapur cab service is designed for long-distance travel with a focus on safety and comfort. This service is ideal for temple visits, family vacations, and business trips. Vehicles are maintained for highway performance. Professional drivers ensure smooth travel. Flexible pickup options across Mumbai add convenience. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Kolhapur Taxi Service",
    description: "Mumbai to Kolhapur taxi service offers dependable intercity transportation for all types of travelers. With well-maintained vehicles and skilled drivers, it ensures a smooth ride. Suitable for families, tourists, and corporate clients. Flexible scheduling allows easy travel planning. It guarantees a stress-free travel experience."
  },
  {
    name: "Cab from Mumbai to Kolhapur",
    description: "Cab from Mumbai to Kolhapur provides a personalized and comfortable road trip experience. Travelers can enjoy private rides with optional stops along the route. This service is ideal for families and groups. Clean vehicles and professional drivers ensure safety. It offers a relaxed and enjoyable journey."
  },
  {
    name: "Taxi from Mumbai to Kolhapur",
    description: "Taxi from Mumbai to Kolhapur offers a convenient and efficient way to travel between the two cities. With experienced drivers and comfortable vehicles, this service ensures a safe journey. Door-to-door service adds convenience. Suitable for short visits and long stays. It ensures a smooth travel experience."
  },
  {
    name: "Mumbai to Kolhapur Cab Booking",
    description: "Mumbai to Kolhapur cab booking allows customers to reserve their ride quickly and easily. Travelers can select vehicle type, pickup location, and travel date as per their needs. Instant confirmation and transparent pricing make the process simple. It ensures a hassle-free booking experience."
  },
  {
    name: "Mumbai to Kolhapur Taxi Booking Online",
    description: "Mumbai to Kolhapur taxi booking online provides a fast and convenient way to book your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation ensure reliability. It simplifies travel planning. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Kolhapur Cab Price",
    description: "Mumbai to Kolhapur cab price varies based on vehicle type, travel duration, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly and premium options are available. Customers can choose according to their needs. It helps in efficient travel planning."
  },
  {
    name: "Mumbai to Kolhapur Taxi Fare",
    description: "Mumbai to Kolhapur taxi fare is designed to be affordable and competitive for long-distance travel. Fare depends on car type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Kolhapur One Way Cab",
    description: "Mumbai to Kolhapur one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges, making it budget-friendly. Ideal for relocations and extended stays. Flexible pickup timings add convenience. It ensures a comfortable journey."
  },
  {
    name: "Mumbai to Kolhapur Round Trip Taxi",
    description: "Mumbai to Kolhapur round trip taxi is ideal for travelers planning a return journey. This package includes pickup, drop, waiting time, and return travel. Flexible schedules allow easy planning. Suitable for family visits and temple trips. It ensures convenience and cost efficiency."
  },
  {
    name: "Mumbai to Kolhapur Innova Cab",
    description: "Mumbai to Kolhapur Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. It is ideal for long-distance journeys. Professional drivers ensure safe travel. It provides a premium experience."
  },
  {
    name: "Mumbai to Kolhapur Ertiga Cab",
    description: "Mumbai to Kolhapur Ertiga cab is suitable for small groups and families looking for an affordable ride. This vehicle offers good mileage and comfortable seating. It is ideal for budget-friendly travel. Drivers ensure smooth and safe journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Kolhapur Sedan Cab",
    description: "Mumbai to Kolhapur sedan cab is perfect for couples and small families seeking economical travel. Sedans offer smooth driving and comfortable seating. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is ideal for a relaxed journey."
  },
  {
    name: "Mumbai to Kolhapur SUV Taxi",
    description: "Mumbai to Kolhapur SUV taxi provides extra space and comfort for long journeys. SUVs offer better performance and stability on highways. This option is ideal for families and group travel. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Kolhapur Cab",
    description: "Cheap Mumbai to Kolhapur cab offers budget-friendly travel options without compromising safety and comfort. This service is ideal for cost-conscious travelers. Economical sedan options are available. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Kolhapur Taxi Service",
    description: "Best Mumbai to Kolhapur taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on safety, punctuality, and customer satisfaction. Customers can choose from multiple vehicle options. Transparent pricing enhances trust. It guarantees a reliable journey."
  }
],

tableData: [
  ["Mumbai to Kolhapur Cab", "Mumbai to Kolhapur Taxi"],
  ["Mumbai to Kolhapur Cab Service", "Mumbai to Kolhapur Taxi Service"],
  ["Cab from Mumbai to Kolhapur", "Taxi from Mumbai to Kolhapur"],
  ["Mumbai to Kolhapur Cab Booking", "Mumbai to Kolhapur Taxi Booking Online"],
  ["Mumbai to Kolhapur Cab Price", "Mumbai to Kolhapur Taxi Fare"],
  ["Mumbai to Kolhapur One Way Cab", "Mumbai to Kolhapur Round Trip Taxi"],
  ["Mumbai to Kolhapur Innova Cab", "Mumbai to Kolhapur Ertiga Cab"],
  ["Mumbai to Kolhapur Sedan Cab", "Mumbai to Kolhapur SUV Taxi"],
  ["Cheap Mumbai to Kolhapur Cab", "Best Mumbai to Kolhapur Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Kolhapur Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Kolhapur cab service, ideal for family trips, religious visits, and long-distance travel."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Kolhapur highway routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden fees."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Kolhapur cab service operates 24/7, allowing flexible travel plans for day or night journeys."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day Kolhapur travel packages as per your needs."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, luxury vehicles, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Kolhapur cab bookings due to punctual service, professional drivers, and reliable travel experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Kolhapur cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Kolhapur for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Kolhapur?", answer: "The distance is approximately 375 to 400 km and takes around 7 to 9 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Kolhapur cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, luxury cars, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak travel seasons." },
  { question: "Do you offer outstation packages?", answer: "Yes, we provide customized outstation travel packages for Kolhapur trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Patil",
    feedback: "The Mumbai to Kolhapur cab service with Royal Route Cabs was very comfortable and well-managed. The highway journey was smooth and the driver was professional throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Deshmukh",
    feedback: "Excellent experience traveling from Mumbai to Kolhapur. The cab was clean, the ride was safe, and the overall service felt reliable and stress-free.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Kolhapur Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-kolhapur-cab.jpg", // replace if needed
  "description": "Book Mumbai to Kolhapur cab with Royal Route Cabs for a safe, comfortable, and affordable journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip travel with professional drivers and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-kolhapur-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Kolhapur Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Kolhapur cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to kolhapur cab, mumbai to kolhapur taxi, mumbai to kolhapur cab service, mumbai to kolhapur taxi service, cab from mumbai to kolhapur, taxi from mumbai to kolhapur, mumbai to kolhapur cab booking, mumbai to kolhapur taxi booking online, mumbai to kolhapur cab price, mumbai to kolhapur taxi fare, mumbai to kolhapur one way cab, mumbai to kolhapur round trip taxi, mumbai to kolhapur innova cab, mumbai to kolhapur ertiga cab, mumbai to kolhapur sedan cab, mumbai to kolhapur suv taxi, cheap mumbai to kolhapur cab, best mumbai to kolhapur taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokolhapurcab;